import React from 'react';
import ReactDOM from 'react-dom/client';
import 'normalize.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('widget-trade-in') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
